/* The Tiny Toddlers redesign: collection pages (t-collection-hero, t-collection-grid).
   Description "Read more", filter drawer, and filters / sort / pagination updated in place with the Section Rendering API.
   Everything also works without JavaScript (plain GET forms and links). */
(function () {
  function root() { return document.querySelector('[data-t-col]'); }
  function preview(u) {
    if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' && u.indexOf('preview_theme_id') === -1) u += (u.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + Shopify.theme.id;
    return u;
  }
  var mq = window.matchMedia('(max-width: 959px)');
  var lastOpener = null;

  /* ----- Description: clamp to ~3 lines with Read more ----- */
  function initDesc() {
    var d = document.querySelector('[data-t-col-desc]'); if (!d || d.dataset.ready) return;
    d.dataset.ready = '1';
    var body = d.querySelector('.t-col-desc-body'), btn = d.querySelector('[data-t-col-more]');
    if (!btn) return; /* short description: no clamp, no button */
    if (body.scrollHeight - body.clientHeight > 4) {
      btn.addEventListener('click', function () {
        var open = d.classList.toggle('t-col-open');
        btn.setAttribute('aria-expanded', open); btn.textContent = open ? 'Read less' : 'Read more';
      });
    } else btn.style.visibility = 'hidden'; /* text fits: keep the space, no layout shift */
  }

  /* ----- Drawer (phones and tablets) ----- */
  function drawer() { var r = root(); return r && r.querySelector('[data-t-col-drawer]'); }
  function setOpen(open, keepFocus) {
    var dr = drawer(), r = root(); if (!dr) return;
    dr.classList.toggle('t-col-on', open);
    document.documentElement.classList.toggle('t-col-lock', open && mq.matches);
    var b = r.querySelector('[data-t-col-open]'); if (b) b.setAttribute('aria-expanded', open);
    var f = dr.querySelector('[data-t-col-filters]'); if (f) f.setAttribute('aria-modal', open && mq.matches ? 'true' : 'false');
    if (open && !keepFocus) { var s = dr.querySelector('summary'); if (s) s.focus(); }
    if (!open && lastOpener && !keepFocus) { var ob = root().querySelector('[data-t-col-open]'); if (ob) ob.focus(); }
  }

  /* ----- Results in place ----- */
  var ctrl;
  function load(url, opts) {
    opts = opts || {};
    var r = root(); if (!r) { location.href = url; return; }
    var wasOpen = drawer() && drawer().classList.contains('t-col-on');
    var focusSel = opts.focusSel;
    if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
    r.classList.add('t-col-busy'); r.setAttribute('aria-busy', 'true');
    var fetchUrl = preview(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(r.dataset.section));
    fetch(fetchUrl, ctrl ? { signal: ctrl.signal } : {}).then(function (x) { return x.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var fresh = d.querySelector('[data-t-col]'); if (!fresh) { location.href = url; return; }
      var openGroups = {};
      r.querySelectorAll('.t-col-group').forEach(function (g, i) { openGroups[i] = g.open; });
      r.innerHTML = fresh.innerHTML;
      r.querySelectorAll('.t-col-group').forEach(function (g, i) { if (i in openGroups) g.open = openGroups[i]; });
      if (!opts.pop) history.pushState({ tcol: 1 }, '', url);
      init();
      if (wasOpen && mq.matches && !opts.closeDrawer) setOpen(true, true);
      else document.documentElement.classList.remove('t-col-lock');
      if (focusSel) { var el = r.querySelector(focusSel); if (el) el.focus({ preventScroll: true }); }
      if (opts.scroll) { var top = r.getBoundingClientRect().top + window.scrollY - 110; if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' }); }
    }).catch(function (e) { if (!e || e.name !== 'AbortError') location.href = url; })
      .then(function () { r.classList.remove('t-col-busy'); r.removeAttribute('aria-busy'); });
  }
  function formUrl(form) {
    var p = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    var base = form.getAttribute('action') || location.pathname, qs = p.toString();
    return base + (qs ? '?' + qs : '');
  }
  function cssEsc(s) { return window.CSS && CSS.escape ? CSS.escape(s) : s.replace(/"/g, '\\"'); }

  var t;
  document.addEventListener('change', function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    var f = e.target.closest('[data-t-col-filters]');
    if (f) {
      var el = e.target, sel = el.name ? '[name="' + cssEsc(el.name) + '"]' + (el.type === 'checkbox' ? '[value="' + cssEsc(el.value) + '"]' : '') : null;
      clearTimeout(t); t = setTimeout(function () { load(formUrl(f), { focusSel: sel }); }, el.type === 'number' ? 600 : 150);
      return;
    }
    if (e.target.matches('[data-t-col-sort-select]')) load(formUrl(e.target.form), { focusSel: '[data-t-col-sort-select]' });
  });
  document.addEventListener('submit', function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    e.preventDefault();
    var close = !!e.target.closest('[data-t-col-filters]');
    clearTimeout(t);
    load(formUrl(e.target), { closeDrawer: close, scroll: close });
  });
  document.addEventListener('click', function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    var a = e.target.closest('a[data-t-col-link]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); load(a.getAttribute('href'), { scroll: !!a.closest('.t-col-pages'), closeDrawer: false, focusSel: a.closest('.t-col-pages') ? 'h1, .t-col-shown' : null }); return; }
    if (e.target.closest('[data-t-col-open]')) { lastOpener = e.target.closest('[data-t-col-open]'); setOpen(true); return; }
    if (e.target.closest('[data-t-col-close]')) { setOpen(false); return; }
    var sa = e.target.closest('[data-t-col-showall]');
    if (sa) { var ul = sa.previousElementSibling; if (ul) ul.classList.add('t-col-all'); sa.hidden = true; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer() && drawer().classList.contains('t-col-on') && mq.matches) setOpen(false);
  });
  window.addEventListener('popstate', function () { if (root()) load(location.pathname + location.search, { pop: true }); });

  function init() {
    initDesc();
    var r = root(); if (!r) return;
    r.classList.add('t-col-js');
    r.querySelectorAll('[data-t-col-showall]').forEach(function (b) { b.hidden = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
